import React from "react";

const SECTIONS = [
  { id: "sec-cover", label: "Cover", num: "" },
  { id: "sec-contents", label: "Contents", num: "01" },
  { id: "sec-objectives", label: "Objectives", num: "02" },
  { id: "sec-scope", label: "Scope", num: "03" },
  { id: "sec-overview", label: "Solution Overview", num: "04" },
  { id: "sec-flow-0", label: "Stock Issuance", num: "05" },
  { id: "sec-flow-1", label: "Stock Distribution to Region", num: "06" },
  { id: "sec-flow-2", label: "Replenishment", num: "07" },
  { id: "sec-flow-3", label: "Order to Install", num: "08" },
  { id: "sec-flow-4", label: "Returns", num: "09" },
  { id: "sec-flow-5", label: "Reporting", num: "10" },
  { id: "sec-roles", label: "Roles & Permissions", num: "11" },
  { id: "sec-integration", label: "Integration Summary", num: "12" },
  { id: "sec-rules", label: "Business Rules & Data", num: "13" },
  { id: "sec-kpis", label: "Key Performance Indicators", num: "14" },
  { id: "sec-open", label: "Open Information", num: "15" },
];

export const DocSidebar = ({ activeId, onNavigate, versions }) => {
  return (
    <aside
      data-testid="doc-sidebar"
      className="w-72 shrink-0 bg-[#0B2545] text-white flex flex-col h-screen sticky top-0"
    >
      <div className="px-6 py-6 border-b border-white/10">
        <div className="font-head text-2xl font-bold tracking-widest">
          NETSTA<span className="text-[#00857C]">R</span>
        </div>
        <div className="overline text-white/50 mt-2">Proposal Studio</div>
      </div>

      <nav className="flex-1 overflow-y-auto thin-scroll py-4">
        <div className="overline text-white/40 px-6 mb-2">Document Sections</div>
        {SECTIONS.map((s) => (
          <button
            key={s.id}
            data-testid={`nav-${s.id}`}
            onClick={() => onNavigate(s.id)}
            className={`w-full text-left px-6 py-2.5 text-sm font-head flex items-center gap-3 transition-colors duration-200 ${
              activeId === s.id
                ? "bg-[#00857C] text-white"
                : "text-white/75 hover:bg-white/10"
            }`}
          >
            <span className="font-label text-[0.6rem] w-5 opacity-60">{s.num}</span>
            {s.label}
          </button>
        ))}
      </nav>

      <div className="border-t border-white/10 px-6 py-4 max-h-56 overflow-y-auto thin-scroll">
        <div className="overline text-white/40 mb-2">Version History</div>
        {(!versions || versions.length === 0) && (
          <div className="text-white/40 text-xs" data-testid="no-versions">No exports yet</div>
        )}
        {versions?.map((v) => (
          <a
            key={v.id}
            data-testid={`version-${v.id}`}
            href={`${process.env.REACT_APP_BACKEND_URL}${`/api/download/${v.id}`}`}
            target="_blank"
            rel="noreferrer"
            className="block py-1.5 group"
          >
            <div className="text-xs text-white/80 group-hover:text-[#00857C] transition-colors font-head">
              {v.version} · {(v.size / 1024 / 1024).toFixed(1)} MB
            </div>
            <div className="text-[0.65rem] text-white/40 font-label">
              {new Date(v.created_at).toLocaleString()}
            </div>
          </a>
        ))}
      </div>
    </aside>
  );
};

export { SECTIONS };
